<template>
    <div v-if="errors.length" class="form-error">
        <div class="row">
            <div class="col-12">
                <b>Gelieve volgende velden correct in te vullen:</b>
                <ul>
                    <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ErrorMessage',
    props: [
        'errors'
    ],
}
</script>
